import {Component} from "@angular/core";
import "../../../../node_modules/photoswipe/dist/photoswipe.min.js";
import "../../../../node_modules/photoswipe/dist/photoswipe-ui-default.min.js";
import {Picture} from "../../model/picture";
import {Image} from "./image.model";
import {PhotoSwipeService} from "./photo-swipe.service";

declare const $: any;
declare let PhotoSwipe: any;
declare let PhotoSwipeUI_Default: any;

@Component({
  selector: 'photo-swipe',
  template: require('./photo-swipe.component.html'),
  styles: [
    require('./photo-swipe.component.scss')
  ]
})

export class PhotoSwipeComponent {

  gallery: any;
  pswp: any;
  galleryPhotos: Image[] = new Array();
  hasComment: boolean;

  constructor(private photoSwipeService: PhotoSwipeService) {

    photoSwipeService.pictureChange$.subscribe(
      state => {
        if (state == 'changed') {

        }

        if (state == 'open') {
          this.openPhotoSwipe();
        }
      }
    );

    photoSwipeService.pictureAdd$.subscribe(
      picture => {
        this.addPicture(picture);
      }
    );
  }

  ngAfterViewInit() {
  }

  galleryClosed() {
    this.photoSwipeService.galleryClosed();
    $('body').removeClass('unscroll');
  }

  galleryAfterChange() {
    this.photoSwipeService.galleryAfterChange(this.gallery.getCurrentIndex());
  }

  galleryBeforeChange() {
    this.photoSwipeService.galleryBeforeChange();
  }

  addPicture(picture: Picture) {
    let image = new Image(picture);
    this.gallery.items.push(image);
    this.gallery.updateSize(true);
  }

  openPhotoSwipe() {
    this.pswp = document.querySelectorAll('.pswp')[0];
    this.galleryPhotos = new Array();

    this.hasComment = this.photoSwipeService.hasComment;

    if(this.hasComment) {
      $('.pswp').removeClass('noComment');
    } else {
      $('.pswp').addClass('noComment');
    }

    for (let picture of this.photoSwipeService.getPictures()) {
      this.galleryPhotos.push(new Image(picture));
    }

    let index = this.photoSwipeService.index > -1 ? this.photoSwipeService.index : 0;

    let options = {
      index: index
    };

    this.gallery = new PhotoSwipe(this.pswp, PhotoSwipeUI_Default, this.galleryPhotos, options);
    this.gallery.init();

    let that = this;

    this.gallery.listen('close', function () {
      that.galleryClosed();
    });

    this.gallery.listen('beforeChange', function () {
      that.galleryBeforeChange();
    });

    this.gallery.listen('afterChange', function () {
      that.galleryAfterChange();
    });

    $('body').addClass('unscroll');
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/photoswipe/photo-swipe.component.ts